var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3594 20.5116H23.2622V2.45522H13.3594V20.5116Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9881 11.4834C13.9881 7.82022 15.6785 4.55765 18.3107 2.45522C16.3855 0.917399 13.9566 0 11.3165 0C5.06645 0 0 5.14139 0 11.4834C0 17.8255 5.06645 22.9669 11.3165 22.9669C13.9566 22.9669 16.3855 22.0495 18.3107 20.5116C15.6785 18.4089 13.9881 15.1466 13.9881 11.4834Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2684 18.5992V18.1536H36.1536L36.0219 18.4601L35.8899 18.1536H35.7751V18.5992H35.8559V18.263L35.9798 18.553H36.0637L36.1876 18.2624V18.5992H36.2684ZM35.5419 18.5992V18.2295H35.689V18.1542H35.3149V18.2295H35.4617V18.5992H35.5419ZM36.6217 11.4833C36.6217 17.8254 31.555 22.9668 25.3052 22.9668C22.6651 22.9668 20.2359 22.0494 18.311 20.5115C20.9433 18.4091 22.6337 15.1465 22.6337 11.4833C22.6337 7.82043 20.9433 4.55786 18.311 2.45511C20.2359 0.917291 22.6651 -0.000106812 25.3052 -0.000106812C31.555 -0.000106812 36.6217 5.14128 36.6217 11.4833Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.fb5ee0ec.svg";
export { ForwardRef as ReactComponent };